<template>
    <div>
        <template v-if="extrasArrayToAdd && extrasArrayToAdd.length > 0">
            <table class="w-100 dark mb-4">
                <tr class="fs-small">
                    <th class="extraNameWidth"></th>
                    <th class="pb-2 text-center" style="width: 100px;">Availability</th>
                    <th class="pb-2 text-center" style="width: 120px;">Price/unit</th>
                    <th class="addRemoveWidth" style="width: 200px;"></th>
                </tr>
                <tr class="extraRow border-bottom-light border-top-light" v-for="extra in extrasArrayToAdd">
                    <td class="darker fs-large pl-2">{{ extra.component.name }} - {{extra.componentPrice.name}}</td>
                    <td class="fs-small text-center">{{showAvailability(extra)}}</td>
                    <td class="fs-small text-center">{{ formatPrice(extra.componentPrice.grossprice) }} €</td>
                    <td class="d-flex flex-row justify-content-center py-2">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('remove', extra)"><i class="ico ico-minus dark fs-smaller m-0"></i></span>
                        <!-- <span class="border-light py-2 px-2 radius-normal mx-2 text-center darker font-weight-600" style="width: 2.2rem">{{extra.quantityToAdd}}</span> -->
                        <input type="number" placeholder="0" min="0" class="text-center fs-larger px-1 py-0 bg-lighter darker" style="width: 2.2rem" v-model="extra.quantityToAdd" @keyup="quantityChanged(extra)" @focus="extraFocused(extra)">
                        <span class="border-light py-2 px-3 radius-normal mx-2 text-center pointer" @click="changeExtraQtd2('add', extra)"><i class="ico ico-add dark fs-smaller m-0"></i></span>
                    </td>
                </tr>
                <tr class="fs-large">
                    <th class="pt-2 pl-2 extraNameWidth">Total</th>
                    <th class="pt-2 pb-2"></th>
                    <th class="pt-2 pb-2 text-center">{{formatPrice(addedExtrasTotalPrice)}} €</th>
                    <th class="pt-2 addRemoveWidth text-center">{{totalExtras}}</th>
                </tr>
            </table>

        </template>

        <div v-else class="fs-large dark text-center p-2">
            There are no extras to show
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import { mapGetters, mapActions } from 'vuex'
export default {
    data: function() {
        return {
            extrasArrayToAdd: null,
            extraItemLoaction: null,
            extrasToAdd: [],
        }
    },
    props: {
        reservation: {
            type: Object
        },
    },
    created: function() {
        this.extrasArrayToAdd = this.reservation.event.eventComponents
        // this.extrasArrayToAdd = JSON.parse(JSON.stringify(this.reservation.event.eventComponents))
        this.extrasArrayToAdd.map(extra => {
            // extra.id = null
            if(!extra.quantityToAdd){
                this.$set(extra, 'quantityToAdd', 0)
            }
        })


    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservationCalculations'
        ]),
        totalExtras: function(){
            let total = 0;

            for(let extra of this.extrasArrayToAdd){
                if(extra.quantityToAdd){
                    total += Number(extra.quantityToAdd)
                }
            }
            // this.$set(this.reservation, 'totalExtas', total)
            return total
        },
        hasSelectedExtras: function() {
            if(!this.extrasArrayToAdd.length == 0){
                return false
            } else {
                let output = false;
                for(let extra of this.extrasArrayToAdd){
                    if(extra.quantity > 0){
                        output = true
                    }
                }
                return output
            }
        },
        addedExtrasTotalPrice: function () {
            let total = 0
            this.extrasArrayToAdd.map(extra => {
                total += extra.quantityToAdd * extra.componentPrice.grossprice
            })
            return total
        }
    },
    methods: {
        ...mapActions([
            'setReservationCalculations'
        ]),
        showAvailability: function(extra) {
            if(extra.quantity == 0){
                return 'unlimited'
            } else {
                return extra.quantityAvailable
            }
        },
        extraQtd: function(extra){
            let total = 0

            if(this.reservation.bookingComponents){
                var currentBookingComponent = this.reservation.bookingComponents.find(bookingComponent => {
                    if(bookingComponent.componentPrice){
                        return bookingComponent.component.id == extra.component.id && bookingComponent.componentPrice.id == extra.componentPrice.id
                    } else {
                        return bookingComponent.component.id == extra.component.id
                    }
                })

                if(currentBookingComponent){
                    total = currentBookingComponent.quantity
                }
            } else {
                total = extra.quantityBooked
            }

            return total
        },
        extraQtd2: function(extra){
            return extra.quantity
        },
        changeExtraQtd2: function(addRemove, extra) {
            if(this.isReservationReadOnly){
                this.readOnlyShowMessage()
                return false
            }

            //add update flag
            if(this.reservation.updateFlags){
                this.$set(this.reservation.updateFlags, 'extras', true)
            }


            if(addRemove == 'add'){
                // is unlimied
                if(extra.quantity == 0){
                extra.quantityToAdd++
                } else {
                    if(extra.quantityAvailable > 0){
                        extra.quantityToAdd++
                        extra.quantityAvailable--
                    }
                }

            } else if(addRemove == 'remove'){
                if(extra.quantityToAdd > 0){
                    extra.quantityToAdd--
                    // not unlimied
                    if(extra.originalQuantity != 0){
                        extra.quantityAvailable++
                    }
                }
            }


        },
        changeExtraQtdCreateReservation: function(addRemove, extra) {
            if(addRemove == 'add'){

                if(!extra.quantityBooked){
                    // extra.quantityBooked = 0;
                    this.$set(extra, 'quantityBooked', 0)
                }
                if(extra.quantity == 0 || extra.quantityBooked < extra.quantityAvailable){
                // if(extra.quantity == 0 || extra.quantityBooked < this.extraQtd(extra)){
                    extra.quantityBooked++;
                }

            } else if(addRemove == 'remove'){

                if(extra.quantityBooked > 0){
                    extra.quantityBooked--;
                }

            }

            //if editing reservation set the total on the right part of the reservation object
            if(this.reservation.bookingComponents){
                this.reservation.bookingComponents.map(bookingComponent => {
                    if(bookingComponent.component.id == extra.component.id){
                        bookingComponent.quantity = extra.quantityBooked
                    }
                })
            }


            //asks api for calculations
            this.setReservationCalculations(this.reservation);
        },
        quantityChanged: function(extra){
            extra.quantityToAdd = Number(extra.quantityToAdd)

            if(extra.quantityToAdd <= 0){
                extra.quantityToAdd = null
            }

            //add update flag
            if(this.reservation.updateFlags){
                this.$set(this.reservation.updateFlags, 'extras', true)
            }

            console.log('extra.quantity', extra.quantity);
            if(extra.quantity != 0 && extra.quantityToAdd > (extra.quantity - (extra.quantityToAdd + extra.quantityBooked))){
                extra.quantityToAdd = extra.quantity - extra.quantityBooked
                this.$toasted.error('Selected quantity can not be higher than available quantity');
            }

            extra.quantityAvailable = extra.quantity - (extra.quantityToAdd + extra.quantityBooked)

            this.setReservationCalculations(this.reservation);
        },
        extraFocused: function (extra) {
            // fix to simulate "placeholder" with 0 value
            if(extra.quantityToAdd == 0){
                extra.quantityToAdd = null
            }
        },
        fixQuantityBooked: function() {
            //when editing reservation the information on reservation.event.eventComponents[x] refers to the total sold of the event
            //so this fix set the reservation.event.eventComponents[x].quantityBooked to the same as in reservation.bookingComponents[x].quantity

            let vm = this

            // vm.reservation.bookingComponents.map(componentA => {
            for(var componentA of vm.reservation.bookingComponents){
                vm.reservation.event.eventComponents.map(componentToFix => {
                    if(componentA.component.id == componentToFix.component.id){
                        componentToFix.quantityBooked = componentA.quantity
                        vm.$set(componentToFix, 'fixed', true)
                    }
                })
            }

            // if there is any wrong quantity remaining (not fixed) will be set to zero
            vm.reservation.event.eventComponents.map(componentToFix => {
                if(!componentToFix.fixed){
                    componentToFix.quantityBooked = 0
                }
            })

        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// AddExtra.vue?51686afe